const sidebarData = {
  title: "",
  link: "",
  items: [
    {
      title: "Documentation",
      link: "",
      items: [
        {
          title: "Home",
          link: "/"
        },
        {
          title: "API Basics",
          link: "documentation/api-basics"
        }
      ]
    },
    {
      title: "Capabilities",
      link: "",
      items: [
        {
          title: "Ticketing",
          link: "documentation/ticketing"
        },
        {
          title: "Help Center",
          link: "documentation/help_center"
        },
        {
          title: "Messaging",
          link: "documentation/conversations"
        },
        {
          title: "Voice",
          link: "documentation/voice"
        },
        {
          title: "Sales CRM",
          link: "documentation/sales-crm"
        },
        {
          title: "Custom Data",
          link: "documentation/custom-data"
        },
        {
          title: "Live Chat",
          link: "documentation/live-chat"
        }
      ]
    },
    {
      title: "Web, iOS, Android and Unity SDKs",
      link: "",
      items: [
        {
          title: "Zendesk Web Widget and SDKs",
          link: "documentation/zendesk-web-widget-sdks"
        },
        {
          title: "Classic Web Widget and SDKs",
          link: "documentation/classic-web-widget-sdks"
        }
      ]
    },
    {
      title: "Extensions",
      link: "",
      items: [
        {
          title: "Apps",
          link: "documentation/apps"
        },
        {
          title: "Marketplace",
          link: "documentation/marketplace"
        },
        {
          title: "Webhooks",
          link: "documentation/webhooks"
        },
        {
          title: "Integration Services",
          link: "documentation/integration-services"
        },
        {
          title: "Channel Framework",
          link: "documentation/channel_framework"
        },
        {
          title: "Amazon EventBridge",
          link: "documentation/amazon-eventbridge"
        }
      ]
    }
  ]
}

export default sidebarData
